import { tr } from 'i18n';
import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import React from 'react';
import { Phone } from 'lucide-react';
import styles from '../ReportCard.module.scss';

const DriverIdentity = ({ name, phone, mobilePhone = false }) => { useInterfaceLanguage(); return (<div className={styles.driverIdentity}>
  <span className={styles.driverIdentityName}>{tr(name || tr("Не указан"))}</span>
  {tr(phone && <a className={`${styles.driverIdentityPhone} ${mobilePhone ? styles.driverIdentityMobilePhone : ''}`} href={`tel:${phone}`} onClick={event => event.stopPropagation()}><Phone size={12} aria-hidden="true" />{tr(phone)}</a>)}
</div>); };

export default DriverIdentity;
